import formCalendar from '@js/components/form-calendar';
import filter from '@js/components/filter';

export default {
  init() {
    filter.init();
    if( $('#js-calendar').length ) {
      formCalendar.create($('#js-calendar'));
    }
    this.listItems();

    $(window).on('resize', () => {
      this.listItems();
    });
  },

  listItems() {
    if (window.outerWidth < 900) {
      $('.post-item--small')
        .removeClass('post-item--small')
        .addClass('post-item--medium post-item--mob');
    } else {
      $('.post-item--mob')
        .removeClass('post-item--medium post-item--mob')
        .addClass('post-item--small');
    }
  },

  finalize() {},
};
